import(/* webpackMode: "eager" */ "/vercel/path0/src/app/referrals/page.tsx");
